import { CALL_API, Schemas } from '../middleware/api'

/**
  Action Creators

  These fire events which the reducer will handle
  We will later call these functions from inside our component

  Later these functions get bound to 'dispatch' fires the actual event
  Right now they just return an object

  It's a code convention to use all capitals and snake case for the event names
  We use const to store the name of the event so it is immutable

*/
export const BATTERIES_REQUEST = 'BATTERIES_REQUEST'
export const BATTERIES_SUCCESS = 'BATTERIES_SUCCESS'
export const BATTERIES_FAILURE = 'BATTERIES_FAILURE'

function fetchBatteriesByBounds(fromLat = -90, fromLon = -180, toLat = 90, toLon = 180, per = 100, page = 0) {
  return {
    [CALL_API]: {
      types: [ BATTERIES_REQUEST, BATTERIES_SUCCESS, BATTERIES_FAILURE ],
      endpoint: `batteries?searchwindow=${fromLat},${fromLon}|${toLat},${toLon}&per=${per}&page=${page}`,
      schema: Schemas.BATTERY_ARRAY
    }
  }
}

export function loadBatteriesByBounds(fromLat = -90, fromLon = -180, toLat = 90, toLon = 180, per = 100, page = 0) {
  return (dispatch, getState) => {
    return dispatch(fetchBatteriesByBounds(fromLat, fromLon, toLat, toLon, per, page))
      .then((response) => {
        // load all pages
        if (per === response.response.result.length) {
          return dispatch(loadBatteriesByBounds(fromLat, fromLon, toLat, toLon, per, ++page))
        } else {
          return response
        }
      })
  }
}


export const BATTERY_REQUEST = 'BATTERY_REQUEST'
export const BATTERY_SUCCESS = 'BATTERY_SUCCESS'
export const BATTERY_FAILURE = 'BATTERY_FAILURE'

function fetchBattery(id) {
  return {
    [CALL_API]: {
      types: [ BATTERY_REQUEST, BATTERY_SUCCESS, BATTERY_FAILURE ],
      endpoint: `batteries/${id}`,
      schema: Schemas.BATTERY
    }
  }
}

export function loadBattery(id) {
  return (dispatch, getState) => {
    return dispatch(fetchBattery(id))
  }
}





export const VIDEOS_REQUEST = 'VIDEOS_REQUEST'
export const VIDEOS_SUCCESS = 'VIDEOS_SUCCESS'
export const VIDEOS_FAILURE = 'VIDEOS_FAILURE'

function fetchVideosByBounds(fromLat = -90, fromLon = -180, toLat = 90, toLon = 180, per = 100, page = 0) {
  return {
    [CALL_API]: {
      types: [ VIDEOS_REQUEST, VIDEOS_SUCCESS, VIDEOS_FAILURE ],
      endpoint: `videos?searchwindow=${fromLat},${fromLon}|${toLat},${toLon}&per=${per}&page=${page}`,
      schema: Schemas.VIDEO_ARRAY
    }
  }
}

export function loadVideosByBounds(fromLat = -90, fromLon = -180, toLat = 90, toLon = 180, per = 100, page = 0) {
  return (dispatch, getState) => {
    return dispatch(fetchVideosByBounds(fromLat, fromLon, toLat, toLon, per, page))
  }
}


export const VIDEO_REQUEST = 'VIDEO_REQUEST'
export const VIDEO_SUCCESS = 'VIDEO_SUCCESS'
export const VIDEO_FAILURE = 'VIDEO_FAILURE'

function fetchVideo(id) {
  return {
    [CALL_API]: {
      types: [ VIDEO_REQUEST, VIDEO_SUCCESS, VIDEO_FAILURE ],
      endpoint: `videos/${id}`,
      schema: Schemas.VIDEO
    }
  }
}

export function loadVideo(id) {
  return (dispatch, getState) => {
    return dispatch(fetchVideo(id))
  }
}





export const AMBASSADORS_REQUEST = 'AMBASSADORS_REQUEST'
export const AMBASSADORS_SUCCESS = 'AMBASSADORS_SUCCESS'
export const AMBASSADORS_FAILURE = 'AMBASSADORS_FAILURE'

function fetchAmbassadorsByBounds(fromLat = -90, fromLon = -180, toLat = 90, toLon = 180, per = 500, page = 0) {
  return {
    [CALL_API]: {
      types: [ AMBASSADORS_REQUEST, AMBASSADORS_SUCCESS, AMBASSADORS_FAILURE ],
      endpoint: `ambassadors?searchwindow=${fromLat},${fromLon}|${toLat},${toLon}&per=${per}&page=${page}`,
      schema: Schemas.AMBASSADOR_ARRAY
    }
  }
}

export function loadAmbassadorsByBounds(fromLat = -90, fromLon = -180, toLat = 90, toLon = 180, per = 500, page = 0) {
  return (dispatch, getState) => {
    return dispatch(fetchAmbassadorsByBounds(fromLat, fromLon, toLat, toLon, per, page))
  }
}


export const AMBASSADOR_REQUEST = 'AMBASSADOR_REQUEST'
export const AMBASSADOR_SUCCESS = 'AMBASSADOR_SUCCESS'
export const AMBASSADOR_FAILURE = 'AMBASSADOR_FAILURE'

function fetchAmbassador(id) {
  return {
    [CALL_API]: {
      types: [ AMBASSADOR_REQUEST, AMBASSADOR_SUCCESS, AMBASSADOR_FAILURE ],
      endpoint: `ambassadors/${id}`,
      schema: Schemas.AMBASSADOR
    }
  }
}

export function loadAmbassador(id) {
  return (dispatch, getState) => {
    return dispatch(fetchAmbassador(id))
  }
}





export const AWARDS_REQUEST = 'AWARDS_REQUEST'
export const AWARDS_SUCCESS = 'AWARDS_SUCCESS'
export const AWARDS_FAILURE = 'AWARDS_FAILURE'

function fetchAwardsByBounds(fromLat = -90, fromLon = -180, toLat = 90, toLon = 180, per = 100, page = 0) {
  return {
    [CALL_API]: {
      types: [ AWARDS_REQUEST, AWARDS_SUCCESS, AWARDS_FAILURE ],
      endpoint: `awards?searchwindow=${fromLat},${fromLon}|${toLat},${toLon}&per=${per}&page=${page}`,
      schema: Schemas.AWARD_ARRAY
    }
  }
}

export function loadAwardsByBounds(fromLat = -90, fromLon = -180, toLat = 90, toLon = 180, per = 100, page = 0) {
  return (dispatch, getState) => {
    return dispatch(fetchAwardsByBounds(fromLat, fromLon, toLat, toLon, per, page))
  }
}


export const AWARD_REQUEST = 'AWARD_REQUEST'
export const AWARD_SUCCESS = 'AWARD_SUCCESS'
export const AWARD_FAILURE = 'AWARD_FAILURE'

function fetchAward(id) {
  return {
    [CALL_API]: {
      types: [ AWARD_REQUEST, AWARD_SUCCESS, AWARD_FAILURE ],
      endpoint: `awards/${id}`,
      schema: Schemas.AWARD
    }
  }
}

export function loadAward(id) {
  return (dispatch, getState) => {
    return dispatch(fetchAward(id))
  }
}






export const SET_ENTITY_IS_LOADING = 'SET_ENTITY_IS_LOADING'

export function setEntityIsLoading(entityType) {
  return {
    type: SET_ENTITY_IS_LOADING,
    entityType,
  }
}

export const UNSET_ENTITY_IS_LOADING = 'UNSET_ENTITY_IS_LOADING'

export function unsetEntityIsLoading() {
  return {
    type: UNSET_ENTITY_IS_LOADING,
  }
}

export const UNSET_SELECTED_ENTITY = 'UNSET_SELECTED_ENTITY'

export function unsetSelectedEntity() {
  return {
    type: UNSET_SELECTED_ENTITY,
  }
}







export const ZOOM_DECREMENT = 'ZOOM_DECREMENT'

export function zoomIncrement() {
  return {
    type: ZOOM_INCREMENT,
  }
}

export const ZOOM_INCREMENT = 'ZOOM_INCREMENT'

export function zoomDecrement() {
  return {
    type: ZOOM_DECREMENT,
  }
}

export const SET_BOUNDS = 'SET_BOUNDS'

export function setBounds(bounds, duration = 1) {
  return {
    type: SET_BOUNDS,
    bounds,
    duration,
  }
}

export const SET_CENTER_HEIGHT = 'SET_CENTER_HEIGHT'

export function setCenterHeight(center, height, duration = 1) {
  return {
    type: SET_CENTER_HEIGHT,
    center,
    height,
    duration,
  }
}

export const SET_VIEWPORT = 'SET_VIEWPORT'

export function setViewport(bounds, center, height, magnitude) {
  return {
    type: SET_VIEWPORT,
    bounds,
    center,
    height,
    magnitude,
  }
}

export const SET_SELECTED_OBJECT = 'SET_SELECTED_OBJECT'

export function setSelectedObject(selectedObject) {
  return {
    type: SET_SELECTED_OBJECT,
    selectedObject,
  }
}

export const SET_MODE = 'SET_MODE'

export function setMode(mode) {
  return {
    type: SET_MODE,
    mode,
  }
}

export const SET_SHOW_FORM = 'SET_SHOW_FORM'

export function setShowForm(showForm) {
  return {
    type: SET_SHOW_FORM,
    showForm,
  }
}

export const SET_CAMERA_IS_FLYING = 'SET_CAMERA_IS_FLYING'

export function setCameraIsFlying(cameraIsFlying) {
  return {
    type: SET_CAMERA_IS_FLYING,
    cameraIsFlying,
  }
}


// WEBPACK FOOTER //
// ./src/actions/index.js